import { selectBuyPackageModalData } from './selectBuyPackageModalData';
import { TAppState } from '../../types';

export const selectBuyPackageModalAutoprolong = (state: TAppState): boolean => {
  const { autoProlong } = selectBuyPackageModalData(state);

  return !!autoProlong;
};
